/**
 * Tipos de consulta configuráveis para a Ficha Clínica
 * Esta lista pode ser expandida conforme necessário
 */

export interface IConsultationType {
  id: number;
  label: string;
  color?: string;
}

// Mapa de IDs de procedimentos para tipos de consulta
export const CONSULTATION_TYPE_MAP: Record<number, string> = {
  2: "1ª Consulta",
  7: "Alta",
  30: "Banda Inferior",
  31: "Banda Superior",
  55: "Colagem Inferior",
  56: "Colagem Superior",
  65: "Controle de Contenção",
  127: "Instalação Aparelho Móvel Inferior",
  128: "Instalação Aparelho Móvel Superior",
  134: "Manutenção",
  136: "Manutenção",
  138: "Manutenção",
  144: "Moldagem Inferior",
  146: "Moldagem Superior",
  201: "Remoção de Aparelho",
  244: "Separador",
  266: "Manutenção",
  285: "Colagem de Tubo",
  290: "Instalação de Contenção Superior e Inferior",
  294: "Instalação de Contenção Superior",
  295: "Instalação de Contenção Inferior",
  440: "Manutenção",
  490: "Manutenção",
  491: "Manutenção",
  492: "Instalação de Aparelho Móvel",
  493: "Moldagem do Aparelho",
};

// Lista de tipos de consulta únicos para filtros e seleção
export const CONSULTATION_TYPES: IConsultationType[] = [
  { id: 1, label: "1ª Consulta", color: "#4CAF50" },
  { id: 2, label: "Manutenção", color: "#2196F3" },
  { id: 3, label: "Controle de Contenção", color: "#9C27B0" },
  { id: 4, label: "Avaliação", color: "#FF9800" },
  { id: 5, label: "Alta", color: "#F44336" },
  { id: 6, label: "Colagem", color: "#00BCD4" },
  { id: 7, label: "Banda", color: "#795548" },
  { id: 8, label: "Instalação Aparelho Móvel", color: "#E91E63" },
  { id: 9, label: "Remoção de Aparelho", color: "#607D8B" },
  { id: 10, label: "Moldagem", color: "#3F51B5" },
  { id: 11, label: "Instalação de Contenção", color: "#009688" },
  { id: 12, label: "Separador", color: "#FFEB3B" },
  { id: 13, label: "Outros", color: "#9E9E9E" },
];

/**
 * Retorna o tipo de consulta baseado no ID do procedimento
 * @param procedureId ID do procedimento
 * @returns Nome do tipo de consulta
 */
export const getConsultationTypeByProcedureId = (procedureId: number): string => {
  return CONSULTATION_TYPE_MAP[procedureId] || "Outros";
};

/**
 * Normaliza o tipo de consulta para o grupo principal
 * Usado para filtros e agrupamentos
 * @param consultationType Nome do tipo de consulta
 * @returns Grupo normalizado do tipo de consulta
 */
export const normalizeConsultationType = (consultationType: string): string => {
  const type = consultationType.toLowerCase();
  
  if (type.includes("manutenção")) return "Manutenção";
  if (type.includes("1ª consulta") || type.includes("1º consulta")) return "1ª Consulta";
  if (type.includes("controle de contenção")) return "Controle de Contenção";
  if (type.includes("alta")) return "Alta";
  if (type.includes("colagem")) return "Colagem";
  if (type.includes("banda")) return "Banda";
  if (type.includes("instalação aparelho móvel") || type.includes("instalacao de aparelho movel")) return "Instalação Aparelho Móvel";
  if (type.includes("remoção de aparelho")) return "Remoção de Aparelho";
  if (type.includes("moldagem")) return "Moldagem";
  if (type.includes("instalação de contenção")) return "Instalação de Contenção";
  if (type.includes("separador")) return "Separador";
  if (type.includes("avaliação")) return "Avaliação";
  
  return "Outros";
};

/**
 * Obtém a cor associada ao tipo de consulta
 * @param consultationType Nome do tipo de consulta
 * @returns Cor hexadecimal
 */
export const getConsultationTypeColor = (consultationType: string): string => {
  const normalizedType = normalizeConsultationType(consultationType);
  const typeConfig = CONSULTATION_TYPES.find(t => t.label === normalizedType);
  return typeConfig?.color || "#9E9E9E";
};

